import {
  ControlItem,
  Dropdown,
  DropdownContent,
  DropdownPortal,
  DropdownTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jana-technology/platform-ui";
import CircleIncompleteIcon from "@material-design-icons/svg/outlined/incomplete_circle.svg?react";
import CircleIcon from "@material-design-icons/svg/outlined/circle.svg?react";

import type {
  MetricSelectProps,
  MetricValue,
  SummariesToggleProps,
} from "./types";

const MetricSelect = <T extends MetricValue>({
  value,
  options,
  itemPrefix,
  onValueChange,
}: MetricSelectProps<T>) => {
  return (
    <div className="p-1">
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          aria-label={`${itemPrefix} metric`}
          className="h-7 w-44 px-2 py-0 text-sm"
        >
          <SelectValue placeholder={`${itemPrefix} metric`} />
        </SelectTrigger>
        <SelectContent>
          {options.map((metricValue) => (
            <SelectItem
              className="text-sm"
              key={`${itemPrefix}-${metricValue}`}
              value={metricValue}
            >
              {`${itemPrefix} ${metricValue}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export const SummariesToggle = <T extends MetricValue>({
  metricEnum,
  selectionMetric,
  systemMetric,
  onSelectionMetricChange,
  onSystemMetricChange,
}: SummariesToggleProps<T>) => {
  const metricOptions = Object.values(metricEnum);

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <div className="itmes-center ml-auto flex animate-slideIn overflow-visible">
          <ControlItem
            className="mr-2.5"
            value="metric"
            title={`Selection ${selectionMetric}`}
          >
            <CircleIncompleteIcon className="fill-current" />
            <span className="sr-only">selection {selectionMetric}</span>
          </ControlItem>
          <ControlItem
            value="metric"
            className="relative -right-2"
            title={`System ${systemMetric}`}
          >
            <CircleIcon className="fill-current" />
            <span className="sr-only">system {systemMetric}</span>
          </ControlItem>
        </div>
      </DropdownTrigger>

      <DropdownPortal>
        <DropdownContent
          className="animate-none overflow-visible rounded-none bg-grey-100 p-0 shadow-none transition-none"
          side="left"
          align="end"
          sideOffset={7}
          alignOffset={-16}
        >
          <div className="pointer-events-none absolute -right-8 bottom-0 left-0 top-0 border border-grey-300 shadow-toast" />
          <div className="absolute -right-8 left-0 top-9 h-0.5 border-t border-t-grey-300" />
          <MetricSelect
            value={selectionMetric}
            options={metricOptions}
            itemPrefix="Selection"
            onValueChange={onSelectionMetricChange}
          />
          <MetricSelect
            value={systemMetric}
            options={metricOptions}
            itemPrefix="System"
            onValueChange={onSystemMetricChange}
          />
        </DropdownContent>
      </DropdownPortal>
    </Dropdown>
  );
};

export default SummariesToggle;
